module.exports = __webpack_public_path__ + "img/lens-167-plus-00.8d1e6b07.png";